import React from "react";
import { ButtonGroup, Label } from "reactstrap";
import EditorSlider from "../../components/EditorSlider/EditorSlider";
import SystemLabel from "../../system/SystemLabel/SystemLabel";

const settingsList = ["width", "height", "posY", "posX"];

export const PositionAndSizeTools = (props) => {
  const { postionAndSizeOnChange, selectedModule } = props;
  const { posY, posX, zIndex, width, height } = selectedModule;
  const { meetingModuleLayoutId } = selectedModule;
  return (
    <div className="pas-settings-list">
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ textAlign: "left" }}>
          <Label className="primary-text">
            <SystemLabel name="LayerLevel" />
          </Label>
        </div>
        <div
          style={{
            /*     marginLeft: "auto", */
            display: "flex",
            paddingBottom: 10,
          }}
        >
          <ButtonGroup size="small" style={{ flexWrap: "wrap", width: "100%" }} aria-label="small outlined button group">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((e, i) => {
              return (
                <div key={i} className={"sq-btn small z-btn" + (zIndex == e ? " active" : "")} onClick={() => postionAndSizeOnChange("zIndex", e, meetingModuleLayoutId)}>
                  {e}
                </div>
              );
            })}
          </ButtonGroup>
        </div>
      </div>
      {settingsList.map((slp, i) => {
        return (
          <React.Fragment key={i}>
            <EditorSlider
              value={parseFloat(selectedModule[slp])}
              defaultValue={1}
              unitChange={(u, p) => null}
              onChange={(s, v, p, ep) => {
                postionAndSizeOnChange(slp, v + "%", meetingModuleLayoutId);
              }}
              units={[]}
              activeUnit={null}
              attachUnit={false}
              steps={0.1}
              max={100 /* -
                (slp == "posX" || slp == "posY"
                  ? parseInt(slp == "posX" ? width : height)
                  : 0) */}
              min={0}
              path={""}
              dark={true}
              label={slp.charAt(0).toUpperCase() + slp.substr(1).toLowerCase()}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
};
